import type { GlobalThemeOverrides } from 'naive-ui'

export const darkThemeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: '#f4f4f5',
    primaryColorHover: '#e4e4e7',
    primaryColorPressed: '#d4d4d8',
    primaryColorSuppl: '#f4f4f5',
    bodyColor: '#0a0a0c',
    cardColor: '#111114',
    modalColor: '#111114',
    popoverColor: '#111114',
    textColorBase: '#f4f4f5',
    textColor1: '#f4f4f5',
    textColor2: '#a1a1aa',
    textColor3: '#71717a',
    borderColor: '#27272a',
    dividerColor: '#1f1f23',
    inputColor: '#0f0f12',
    actionColor: '#161619',
    hoverColor: '#161619',
    fontSize: '13px',
    fontFamily: 'ui-sans-serif, -apple-system, BlinkMacSystemFont, "Inter", "PingFang SC", "Microsoft YaHei", system-ui, sans-serif',
  },
}

export const lightThemeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: '#18181b',
    primaryColorHover: '#27272a',
    primaryColorPressed: '#3f3f46',
    primaryColorSuppl: '#18181b',
    bodyColor: '#ffffff',
    cardColor: '#ffffff',
    modalColor: '#ffffff',
    popoverColor: '#ffffff',
    textColorBase: '#18181b',
    textColor1: '#18181b',
    textColor2: '#52525b',
    textColor3: '#a1a1aa',
    borderColor: '#e4e4e7',
    dividerColor: '#f1f1f3',
    inputColor: '#fafafa',
    actionColor: '#f4f4f5',
    hoverColor: '#f4f4f5',
    fontSize: '13px',
    fontFamily: 'ui-sans-serif, -apple-system, BlinkMacSystemFont, "Inter", "PingFang SC", "Microsoft YaHei", system-ui, sans-serif',
  },
}
